import { Component, OnInit, inject } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import appPackage from 'package.json';
import { SharedModule } from '@shared/shared.module';
import { AuthService, ToastService } from '@core/services';
import { hasErrorAndTouched } from '@shared/utils';
import { LanguageSwitchComponent } from '../../../components/base-header/user-action/language-switch/language-switch.component';
import { pageUrls } from 'src/app/configuration/pages';
import { ThemeSwitchComponent } from '../../../components/base-header/user-action/theme-switch/theme-switch.component';
import { ValidationMessageService } from '@shared/validators';
import { catchError } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [SharedModule, LanguageSwitchComponent, ThemeSwitchComponent],
})
export class LoginComponent implements OnInit {
  readonly hasErrorAndTouched = hasErrorAndTouched;
  protected readonly validationMessageService = inject(ValidationMessageService);
  authService = inject(AuthService);
  fb = inject(FormBuilder);
  router = inject(Router);
  toastService = inject(ToastService);

  appName = appPackage.title;
  appVersion = `v${appPackage.version}`;
  loginForm = this.fb.group({
    identifier: ['', Validators.required],
    password: ['', Validators.required],
  });

  constructor() {}
  ngOnInit(): void {
    if (this.authService.authenticated) this.authService.redirectAfterLogin();
  }

  get disableSubmitForm(): boolean {
    return this.loginForm.invalid;
  }

  onSubmit() {
    const { identifier, password } = this.loginForm.value;

    this.authService
      .login(identifier as string, password as string)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.authService.redirectAfterLogin());
  }

  /**
   * Redirect to password forget page.
   */
  redirectPasswordForgot() {
    return this.router.navigateByUrl(`/${pageUrls.passwordForgot}`, { replaceUrl: true });
  }
}
